export const initialState = {
  library: [],
  templates: [],
  runs: [],
  runsDate: null,
  history: [],
  // Staff at the selected site that checklists can be assigned to.
  assignees: [],
  // Server clock at the last fetch. Overdue badges compare against this plus
  // elapsed time, so a phone with a wrong clock still shows the right state.
  serverTime: null,
  fetchedAt: null
};

// Replace one run wherever it appears, so a tick saved on the detail screen is
// already reflected on the list when the user goes back.
const replaceRun = (list, run) =>
  (list || []).some(r => r._id === run._id)
    ? list.map(r => (r._id === run._id ? run : r))
    : list;

export default function checklistsReducer(state = initialState, action) {
  switch (action.type) {
    case 'CHECKLISTS_FIND_LIBRARY':
      return { ...state, library: (action.data && action.data.library) || [] };

    case 'CHECKLISTS_FIND_TEMPLATES':
      return { ...state, templates: (action.data && action.data.templates) || [] };

    case 'CHECKLISTS_FIND_RUNS':
      return {
        ...state,
        runs: (action.data && action.data.runs) || [],
        runsDate: action.data && action.data.date,
        serverTime: action.data && action.data.serverTime,
        fetchedAt: Date.now()
      };

    case 'CHECKLISTS_FIND_HISTORY':
      return { ...state, history: (action.data && action.data.runs) || [] };

    case 'CHECKLISTS_FIND_ASSIGNEES':
      return { ...state, assignees: (action.data && action.data.assignees) || [] };

    case 'CHECKLISTS_UPDATE_RUN': {
      const run = action.data && action.data.run;
      if (!run) return state;
      // A newly started on-demand run for today joins the list.
      const runs =
        state.runsDate === run.date && !state.runs.some(r => r._id === run._id)
          ? [...state.runs, run]
          : replaceRun(state.runs, run);
      return { ...state, runs, history: replaceRun(state.history, run) };
    }

    default:
      return state;
  }
}
